import { getBodyData } from 'store/selectors';

export const getProductDeviceDetailsModal = (state) => getBodyData(state).detailsModal || {};

export const getProductDeviceDetailsIsFetching = (state) =>
  getProductDeviceDetailsModal(state).isFetching;
export const getProductDeviceDetailsIsError = (state) =>
  getProductDeviceDetailsModal(state).isError;
export const getProductDeviceDetailsIsPurchaseLoading = (state) =>
  getProductDeviceDetailsModal(state).isPurchaseLoading;
export const getProductDeviceDetailsData = (state) => getProductDeviceDetailsModal(state).data;
